/* ============================================================
   BANYO ATELIER — GROHE tarzı finish swatch'ları
   Renkler ayrı ürün olduğu için SKU bazlı kardeş-ürün haritası
   (grohe-finish-map.json) üzerinden kart altına swatch basar.
   ============================================================ */
(function () {
  'use strict';

  var MAP_URL = window.GROHE_FINISH_MAP_URL;
  if (!MAP_URL) return;

  /* ============================================================
     GLOBAL swatch CSS — temel boyut/daire + renkler + hover.
     Önceden bu stil yalnızca grohe-v2-base (vitrin) ve
     .gpd__swatches (ürün detay) içindeydi; koleksiyon kartlarına
     (card-product) gelmediği için swatch'lar 2px/şeffaf görünüyordu.
     JS'e taşındı → swatch nerede render edilirse CSS de gelir.
     ============================================================ */
  (function injectSwatchCSS() {
    if (document.getElementById('grohe-swatch-css')) return;
    var css = [
      '.grohe-swatches{display:flex;flex-wrap:wrap;gap:.5rem;align-items:center;}',
      '.grohe-swatch{width:1.8rem;height:1.8rem;border-radius:50%;display:inline-block;flex:0 0 auto;',
      /* temel arka plan = nötr gri; bilinen renk sınıfları bunu ezer, bilinmeyen
         (yeni) finish kodu şeffaf/görünmez kalmaz. */
      'background:#c4c8cc;box-shadow:inset 0 0 0 1px rgba(12,29,43,.18);cursor:pointer;transition:transform .12s ease,box-shadow .12s ease;text-decoration:none;}',
      '.grohe-swatch:hover{transform:scale(1.18);box-shadow:inset 0 0 0 1px rgba(12,29,43,.18),0 0 0 2px #16324F;}',
      '.grohe-swatch.is-current{box-shadow:inset 0 0 0 1px rgba(12,29,43,.18),0 0 0 2px #C9A24B;}',
      '.grohe-swatch-more{font-size:1.1rem;font-weight:600;color:#5D6B7A;align-self:center;margin-left:.2rem;}',
      '.grohe-swatch.gsw-c-krom{background:linear-gradient(135deg,#fff 10%,#cfd2d3 48%,#fff 88%);}',
      '.grohe-swatch.gsw-c-beyaz{background:#f4f4f2;}',
      '.grohe-swatch.gsw-c-matbeyaz{background:#e9e9e6;}',
      '.grohe-swatch.gsw-c-siyah{background:#17191a;}',
      '.grohe-swatch.gsw-c-matsiyah{background:#2a2c2d;}',
      '.grohe-swatch.gsw-c-altin{background:linear-gradient(135deg,#e8d49a,#b08d3f);}',
      '.grohe-swatch.gsw-c-nikel{background:linear-gradient(135deg,#e6e6e2,#a9aaa6);}',
      '.grohe-swatch.gsw-c-bakir{background:linear-gradient(135deg,#d9a179,#8f5b3a);}',
      '.grohe-swatch.gsw-c-bronz{background:linear-gradient(135deg,#bba797,#574942);}',
      '.grohe-swatch.gsw-c-antrasit{background:#3a3d40;}',
      '.grohe-swatch.gsw-c-fume{background:#5d6166;}',
      '.grohe-swatch.gsw-c-gri{background:#9ea3a8;}',
      '.grohe-swatch.gsw-c-bej{background:#d9c9b0;}',
      '.grohe-swatch.gsw-c-kasmir{background:linear-gradient(135deg,#dfc4a5,#a98868);}',
      '.grohe-swatch.gsw-c-krem{background:#efe6d4;}',
      '.grohe-swatch.gsw-c-pembe{background:#e8b4c0;}',
      '.grohe-swatch.gsw-c-mavi{background:#4a7fb5;}',
      '.grohe-swatch.gsw-c-yesil{background:#5f8f6a;}',
      '.grohe-swatch.gsw-c-kirmizi{background:#b74040;}',
      '.grohe-swatch.gsw-c-turuncu{background:#d97b3f;}',
      '.grohe-swatch.gsw-c-sari{background:#e3c33f;}',
      '.grohe-swatch.gsw-c-lacivert{background:#23395d;}',
      '.grohe-swatch.gsw-c-haki{background:#7a7a52;}',
      '.grohe-swatch.gsw-c-turkuaz{background:#4fa8a8;}',
      '.grohe-swatch.gsw-c-ceviz{background:linear-gradient(135deg,#8a5f3d,#5d3d24);}',
      '.grohe-swatch.gsw-c-mese{background:linear-gradient(135deg,#c9a877,#8f7040);}',
      '.grohe-swatch.gsw-c-taupe{background:#a99d90;}',
      '.grohe-swatch.gsw-c-mint{background:#a8cbb4;}',
      '.grohe-swatch.gsw-c-somon{background:#e9a58c;}',
      /* --- GROHE gerçek finish renkleri (SKU haritası: chrome/supersteel/...) ---
         Bu kodlar 'c-' önekli değil; kendi sınıflarını alır. cool-sunrise (rose
         gold) ile warm-sunset (bakır) görsel olarak farklıdır — ayrı tutulur.
         Fırçalı (brushed) tonlar parlak eşinden bir tık mat/açık. */
      '.grohe-swatch.gsw-chrome{background:linear-gradient(135deg,#fff 6%,#c6cacc 45%,#eef1f2 68%,#a7adb0 94%);}',
      '.grohe-swatch.gsw-supersteel{background:linear-gradient(135deg,#e2e4e1,#b4b6b1 58%,#98999a);}',
      '.grohe-swatch.gsw-polished-nickel{background:linear-gradient(135deg,#efe8d9,#c4b89d);}',
      '.grohe-swatch.gsw-hard-graphite{background:linear-gradient(135deg,#4a4d50,#2b2e30);}',
      '.grohe-swatch.gsw-brushed-hard-graphite{background:linear-gradient(135deg,#565a5d,#35393b 62%,#282b2d);}',
      '.grohe-swatch.gsw-warm-sunset{background:linear-gradient(135deg,#e8a877,#b06c3f 60%,#89502d);}',
      '.grohe-swatch.gsw-brushed-warm-sunset{background:linear-gradient(135deg,#d6a584,#a56b47 60%,#825233);}',
      '.grohe-swatch.gsw-cool-sunrise{background:linear-gradient(135deg,#f2c8ae,#cf9270 60%,#b0745a);}',
      '.grohe-swatch.gsw-brushed-cool-sunrise{background:linear-gradient(135deg,#e7bfa8,#c69076 60%,#a5705a);}',
      '.grohe-swatch.gsw-matte-black{background:#232526;}',
      '.grohe-swatch.gsw-white{background:#f4f4f2;}'
    ].join('');
    var st = document.createElement('style');
    st.id = 'grohe-swatch-css';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  })();

  var finishMap = null;
  var pending = false;
  var MAX_VISIBLE = 6;

  function normSku(sku) {
    var s = (sku || '').trim().toUpperCase();
    if (s.indexOf('10GRO') === 0) return s.slice(5);
    if (s.indexOf('GRH.') === 0) return s.slice(4);
    if (s.indexOf('GRH') === 0) return s.slice(3);
    return s;
  }

  function lookupGroup(el) {
    /* 1) GROHE: SKU ilk 5 hane -> sku haritası; 2) diğer markalar: handle haritası */
    var bySku = finishMap.sku || finishMap;
    var byHandle = finishMap.handle || {};
    var code = normSku(el.getAttribute('data-sku'));
    if (code && code.length >= 8) {
      var base = code.slice(0, 5);
      if (/^\d{5}$/.test(base) && bySku[base]) return bySku[base];
    }
    var url = el.getAttribute('data-url') || '';
    var m = url.match(/\/products\/([^\/?#]+)/);
    if (m && byHandle[m[1]]) return byHandle[m[1]];
    return null;
  }

  function render() {
    if (!finishMap) return;
    var nodes = document.querySelectorAll('.grohe-swatches:not([data-gsw-done])');
    nodes.forEach(function (el) {
      el.setAttribute('data-gsw-done', '1');
      var group = lookupGroup(el);
      if (!group || group.length < 2) return;

      var currentUrl = el.getAttribute('data-url') || '';
      var frag = document.createDocumentFragment();
      var shown = 0;

      group.forEach(function (item) {
        if (shown >= MAX_VISIBLE) return;
        var a = document.createElement('a');
        a.className = 'grohe-swatch gsw-' + item.c;
        a.href = '/products/' + item.h;
        a.title = item.l;
        a.setAttribute('aria-label', item.l);
        if (currentUrl.indexOf('/products/' + item.h) !== -1) {
          a.classList.add('is-current');
        }
        frag.appendChild(a);
        shown++;
      });

      if (group.length > MAX_VISIBLE) {
        var more = document.createElement('span');
        more.className = 'grohe-swatch-more';
        more.textContent = '+' + (group.length - MAX_VISIBLE);
        frag.appendChild(more);
      }

      el.appendChild(frag);

      /* Ürün sayfası: geçerli rengin adını etikete yaz */
      var lblHost = el.closest('.gpd__finish') || el.parentElement;
      var lbl = lblHost ? lblHost.querySelector('[data-gsw-label]') : null;
      if (lbl) {
        for (var gi = 0; gi < group.length; gi++) {
          if (currentUrl.indexOf('/products/' + group[gi].h) !== -1) {
            lbl.textContent = group[gi].l;
            break;
          }
        }
      }
    });
  }

  function load() {
    if (finishMap || pending) { render(); return; }
    pending = true;
    fetch(MAP_URL)
      .then(function (r) { return r.json(); })
      .then(function (data) { finishMap = data; render(); })
      .catch(function () { /* sessiz geç */ })
      .finally(function () { pending = false; });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }

  /* Sonsuz kaydırma / filtre AJAX yenilemeleri için */
  var mo = new MutationObserver(function () {
    if (document.querySelector('.grohe-swatches:not([data-gsw-done])')) {
      load();
    }
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });

  /* ============================================================
     Swatch hover: kardeş rengin görselini karta anlık yansıt
     ============================================================ */
  var imgCache = {};

  function cardImg(sw) {
    var root = sw.closest('.gv2c') || sw.closest('.card-wrapper') || sw.closest('.card') ||
               sw.closest('.banyo-vitrin__product-card');
    if (!root) return null;
    return root.querySelector('.gv2c__tile img, .card__media img, .banyo-vitrin__product-image');
  }

  function fetchImg(handle) {
    if (imgCache[handle] !== undefined) {
      return Promise.resolve(imgCache[handle]);
    }
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) {
        var src = p && (p.featured_image || (p.images && p.images[0])) || null;
        if (src && src.indexOf('//') === 0) src = 'https:' + src;
        imgCache[handle] = src;
        return src;
      })
      .catch(function () { imgCache[handle] = null; return null; });
  }

  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('a.grohe-swatch');
    if (!sw) return;
    var m = (sw.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var img = cardImg(sw);
    if (!img) return;
    if (!img.dataset.gswOrig) {
      img.dataset.gswOrig = img.src;
      img.dataset.gswOrigSrcset = img.srcset || '';
    }
    var handle = m[1];
    img.dataset.gswWant = handle;
    fetchImg(handle).then(function (src) {
      if (src && img.dataset.gswWant === handle) {
        img.srcset = '';
        img.src = src;
      }
    });
  });

  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('a.grohe-swatch');
    if (!sw) return;
    var img = cardImg(sw);
    if (!img || !img.dataset.gswOrig) return;
    img.dataset.gswWant = '';
    img.src = img.dataset.gswOrig;
    if (img.dataset.gswOrigSrcset) img.srcset = img.dataset.gswOrigSrcset;
  });

  /* ============================================================
     ÜRÜN DETAY hover önizleme: kardeş rengin adı, fiyatı, stok
     bilgisi ve görseli hover ile anlık değişir; ayrılınca döner.
     ============================================================ */
  var pCache = {};
  function fetchProduct(handle) {
    if (pCache[handle] !== undefined) return Promise.resolve(pCache[handle]);
    return fetch('/products/' + handle + '.js')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { pCache[handle] = p; return p; })
      .catch(function () { pCache[handle] = null; return null; });
  }
  function moneyTL(cents) {
    return (cents / 100).toLocaleString('tr-TR', { minimumFractionDigits: 2 }) + 'TL';
  }
  function gpdEls() {
    return {
      title: document.querySelector('.gpd__title'),
      sku: document.querySelector('.gpd__sku'),
      priceNow: document.querySelector('.gpd__price-now'),
      priceList: document.querySelector('.gpd__price-list'),
      stock: document.querySelector('.gpd__stock'),
      label: document.querySelector('.gpd__finish [data-gsw-label]'),
      main: document.getElementById('gpd-main')
    };
  }
  var gpdOrig = null;
  function gpdSnapshot() {
    if (gpdOrig) return;
    var el = gpdEls();
    if (!el.title) return;
    gpdOrig = {
      title: el.title.textContent,
      sku: el.sku ? el.sku.textContent : '',
      priceNow: el.priceNow ? el.priceNow.textContent : '',
      priceListHTML: el.priceList ? el.priceList.innerHTML : null,
      priceListShown: el.priceList ? el.priceList.style.display : null,
      stockHTML: el.stock ? el.stock.innerHTML : '',
      stockOut: el.stock ? el.stock.classList.contains('gpd__stock--out') : false,
      label: el.label ? el.label.textContent : '',
      mainSrc: el.main ? el.main.src : null
    };
  }
  function gpdRestore() {
    if (!gpdOrig) return;
    var el = gpdEls();
    if (el.title) el.title.textContent = gpdOrig.title;
    if (el.sku) el.sku.textContent = gpdOrig.sku;
    if (el.priceNow) el.priceNow.textContent = gpdOrig.priceNow;
    if (el.priceList && gpdOrig.priceListHTML !== null) {
      el.priceList.innerHTML = gpdOrig.priceListHTML;
      el.priceList.style.display = gpdOrig.priceListShown || '';
    }
    if (el.stock) {
      el.stock.innerHTML = gpdOrig.stockHTML;
      el.stock.classList.toggle('gpd__stock--out', gpdOrig.stockOut);
    }
    if (el.label) el.label.textContent = gpdOrig.label;
    if (el.main && gpdOrig.mainSrc) { el.main.srcset = ''; el.main.src = gpdOrig.mainSrc; }
  }
  document.addEventListener('mouseover', function (e) {
    var sw = e.target.closest && e.target.closest('.gpd__swatches a.grohe-swatch');
    if (!sw || sw.classList.contains('is-current')) return;
    var m = (sw.getAttribute('href') || '').match(/\/products\/([^\/?#]+)/);
    if (!m) return;
    var handle = m[1];
    gpdSnapshot();
    if (!gpdOrig) return;
    document.documentElement.dataset.gpdWant = handle;
    fetchProduct(handle).then(function (p) {
      if (!p || document.documentElement.dataset.gpdWant !== handle) return;
      var el = gpdEls();
      var v = p.variants && p.variants[0];
      if (el.title) el.title.textContent = p.title;
      if (el.sku && v && v.sku) el.sku.textContent = v.sku;
      if (el.priceNow) el.priceNow.textContent = moneyTL(p.price);
      if (el.priceList) {
        if (p.compare_at_price && p.compare_at_price > p.price) {
          el.priceList.innerHTML = '<s>' + moneyTL(p.compare_at_price) + '</s> Liste';
          el.priceList.style.display = '';
        } else {
          el.priceList.style.display = 'none';
        }
      }
      if (el.stock) {
        el.stock.innerHTML = p.available ? '● Stokta — hemen gönderim' : '● Stokta yok — tedarik süresi için bize ulaşın';
        el.stock.classList.toggle('gpd__stock--out', !p.available);
      }
      if (el.label) el.label.textContent = sw.getAttribute('title') || '';
      var src = p.featured_image || (p.images && p.images[0]);
      if (el.main && src) {
        if (src.indexOf('//') === 0) src = 'https:' + src;
        el.main.srcset = ''; el.main.src = src;
      }
    });
  });
  document.addEventListener('mouseout', function (e) {
    var sw = e.target.closest && e.target.closest('.gpd__swatches a.grohe-swatch');
    if (!sw) return;
    var to = e.relatedTarget;
    if (to && to.closest && to.closest('.gpd__swatches a.grohe-swatch')) return;
    document.documentElement.dataset.gpdWant = '';
    gpdRestore();
  });
})();